import * as React from 'react';

import { Bem } from '../../../service/Bem/Bem';
import { BannerImageForEdit } from '../../../typings/domain';
import { TickOverlay } from '../../TickOverlay/TickOverlay';

import './ImageGalleryItem.css';

export interface ImageGalleryItemData {
    image: BannerImageForEdit;
    isChecked: boolean;
}

export interface ImageGalleryItemProps extends ImageGalleryItemData {
    onItemSelect: (id: string) => void;
}

const BLOCK = 'image-gallery-item';

export class ImageGalleryItem extends React.Component<ImageGalleryItemProps> {
    render() {
        const {
            image: { url, name, height, width },
            isChecked
        } = this.props;

        return (
            <div
                className={Bem.cls(BLOCK, '', {
                    checked: Boolean(isChecked)
                })}
                onClick={this.onItemSelect}
            >
                <div
                    className={Bem.cls(BLOCK, 'image-wrapper')}
                    style={{ backgroundImage: `url(${url})` }}
                >
                    <TickOverlay isVisible={isChecked} />
                </div>
                <div className={Bem.cls(BLOCK, 'name')}>{name}</div>
                <div
                    className={Bem.cls(BLOCK, 'size')}
                >{`${width}x${height}`}</div>
            </div>
        );
    }

    private onItemSelect = () => {
        const {
            image: { hash },
            onItemSelect
        } = this.props;

        if (hash) {
            onItemSelect(hash);
        }
    };
}
